import React from 'react';
import LoadingIndicator from '@src/components/LoadingIndicator/LoadingIndicator';
import classnames from '@src/helpers/classnames';
import useIsLoading from '@src/hooks/useIsLoading';

export default function Loader(props: { display?: boolean, className?: string }) {
    const isLoading = useIsLoading();
    const shouldHide = !isLoading || props.display === false;

    return <LoadingIndicator
            type="linear"
            className={classnames(props.className, {'opacity-0': shouldHide})}
            style={{transition: 'opacity 300ms ease'}}
    />;
}
